import React from 'react';
import PropTypes from 'prop-types';
import { ResourceRequestStatus } from '~/types';
import { useMeContext } from '~/modules/me';
import { ResourceRequestChartBanner } from '~/modules/resourcing/common/components';
import { ResourceRequestProposeAcceptAllButton } from './ResourceRequestProposeAcceptAllButton';
import {
  hasEditProjectAndTeamPermission,
  hasResourceAllocationEditPermission
} from './util';

export const ResourceRequestProposeAcceptAllChartBanner = ({
  resourceRequests,
  project
}) => {
  const me = useMeContext();

  const hasPermission = hasResourceAllocationEditPermission(me.permissions);
  const proposedResourceRequests = hasPermission
    ? resourceRequests.filter(
        resourceRequest =>
          resourceRequest.requestStatus === ResourceRequestStatus.Tentative &&
          hasEditProjectAndTeamPermission(resourceRequest, project)
      )
    : [];

  return proposedResourceRequests.length ? (
    <ResourceRequestChartBanner messageId="resourceRequestChartBanner.proposedRequests">
      <ResourceRequestProposeAcceptAllButton
        proposedResourceRequests={proposedResourceRequests}
      />
    </ResourceRequestChartBanner>
  ) : null;
};

ResourceRequestProposeAcceptAllChartBanner.propTypes = {
  resourceRequests: PropTypes.array.isRequired,
  project: PropTypes.object
};
export default ResourceRequestProposeAcceptAllChartBanner;
